import { reduxForm } from 'redux-form'
import at from 'lodash/at'
import get from 'lodash/get'

import { goBack } from 'react-router-redux'
import { loadSubLocationsByLocation } from '../../actions/sub-locations'
import { setSubLocationFilterForLocation } from '../../actions/work-tracker-filters'

import WorkTrackerFilterModal from '../../components/work-trackers/work-tracker-filter-modal'

const fields = [
  'resourceId'
]

function mapStateToProps (state, ownProps) {
  const id = ownProps.params.locationId
  let ids = []
  let resources = []

  if (state.pagination.subLocationsByLocation[id]) {
    ids = state.pagination.subLocationsByLocation[id].ids
    resources = at(state.subLocations, ids || [])
  }

  return {
    resourceName: 'sub-location',
    modalTitle: 'Choose a Sub-Location',
    hasNextPage: get(state, `pagination.subLocationsByLocation.${id}.nextPageUrl`),
    initialValues: {
      resourceId: get(state, `workTrackerFilters.${id}.subLocationId`)
    },
    resources
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  const id = ownProps.params.locationId

  dispatch(loadSubLocationsByLocation(id))

  return {
    handleClose () {
      dispatch(goBack())
    },

    onLoadNextPage () {
      dispatch(loadSubLocationsByLocation(id, true))
    },

    onSubmit (data) {
      dispatch(setSubLocationFilterForLocation(id, data.resourceId))
      dispatch(goBack())
    }
  }
}

export default reduxForm(
  {
    fields,
    form: 'filterContract'
  },
  mapStateToProps,
  mapDispatchToProps
)(WorkTrackerFilterModal)



// WEBPACK FOOTER //
// ./src/containers/work-trackers/work-tracker-sub-location-filter-container.js